import { render, staticRenderFns } from "./myCreatList.vue?vue&type=template&id=075270cd"
import script from "./myCreatList.vue?vue&type=script&lang=js"
export * from "./myCreatList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports